import React, { Fragment } from 'react';

export default () => (
  <Fragment>
    <h1 className="ui header dividing">Welcome to Clearing Admin UI</h1>
  </Fragment>
);
